import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useCommonStore } from '../../../../store/store';
import PropTypes from 'prop-types';
import { agentProfileRoute } from '../../../../agent-production/constants/agentProductionConstants';
import FavoriteAgent from './FavoriteAgent';

export const AgentProfileLink = (props) => {
    const location = useLocation();
    const history = useHistory();
    const {
        clearAgentListPopover,
        setAgentDetailNavigation,
    } = useCommonStore(state => ({
        clearAgentListPopover: state.clearAgentListPopover,
        setAgentDetailNavigation: state.setAgentDetailNavigation
    }));

    const handleClick = () => {
        clearAgentListPopover();
        setAgentDetailNavigation({ incomingPage: location.pathname, tabIndex: 0 });
        history.push(
            `${agentProfileRoute}?id=${props.data.agentId}`,
            { fromOfficeBreakdownAndGrowthTab: location.state?.fromOfficeBreakdownAndGrowthTab },
        );
    };

    if (props?.data?.hasFavStar) {
        return (
            <div className="agent-favorite-wrapper">
                <span
                    className="table-row-link clickable agent-name-limited"
                    onClick={handleClick}
                    title={props.data.agentName}
                >
                    {props.data.agentName}
                </span>
                <FavoriteAgent {...props} />
            </div>
        );
    }        
    return (
        <span
            className='table-row-link clickable'
            onClick={handleClick}
        >
            {props.data.agentName}
        </span>
    );
};

AgentProfileLink.propTypes = {
    data: PropTypes.object
};

